import Grid from '@mui/material/Grid';

import { useDinerAccount } from 'reservations/dinerAccount/hooks/useDinerAccount';
import { BookingFields } from 'reservations/form/components/BookingFields';
import DinerInformationReadOnly from 'reservations/form/components/DinerInformationReadOnly';
import { DinerLoginFields } from 'reservations/form/components/DinerLoginFields';

export const DinerAuthenticationFields = () => {
  const { isDinerAccountAuthenticated } = useDinerAccount();
  return isDinerAccountAuthenticated ? (
    <>
      <Grid item>
        <DinerInformationReadOnly />
      </Grid>
      <Grid container item gap="16px" direction="column">
        <BookingFields />
      </Grid>
    </>
  ) : (
    <Grid container item gap="16px" direction="column">
      <DinerLoginFields />
      <BookingFields />
    </Grid>
  );
};
